module.exports = "/fonts/segoe-ui-bold-italic.ttf";